import styled, { CSSObject } from 'styled-components';

import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

export type PremiumTagProps = {};

const COMMON_STYLES: CSSObject = {
  content: '""',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  borderRadius: pxToRem(16),
  background: 'linear-gradient(120deg, #005FFF, #E039CE)',
};

type TagProps = {
  text: string;
};

const Tag = ({ text }: TagProps) => {
  return (
    <div style={{ position: 'relative', width: 'fit-content' }}>
      <Container>
        <Text aiGradient font="semibold12" text={text} />
      </Container>
    </div>
  );
};

export const PremiumTag = () => {
  const { t } = useScopedTranslate(locale);
  return <Tag text={t('premium')} />;
};

export const EnterpriseTag = () => {
  const { t } = useScopedTranslate(locale);
  return <Tag text={t('enterprise')} />;
};

const Container = styled.div({
  width: 'fit-content',
  padding: `${pxToRem(4)} ${pxToRem(16)}`,
  ':before': {
    ...COMMON_STYLES,
    padding: pxToRem(1),
    WebkitMask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
  ':after': {
    ...COMMON_STYLES,
    opacity: 0.1,
    zIndex: -1,
  },
});

const locale = {
  en: {
    premium: 'Premium',
    enterprise: 'Enterprise',
  },
};
